import {
  Select as NextUISelect,
  SelectItem as NextUISelectItem,
  SelectSection as NextUISelectSection,
  extendVariants
} from '@heroui/react';

export const Select = ({ classNames, listboxProps, ...props }: React.ComponentProps<typeof NextUISelect>) => (
  <NextUISelect
    classNames={{
      trigger: 'h-9.5 min-h-9.5 max-h-9.5 rounded-lg border border-divider bg-content2 shadow-none text-content2-foreground',
      ...classNames,
    }}
    listboxProps={{
      className: 'px-0',
      itemClasses: {
        base: [
          'rounded-none',
          'py-1.5',
          'px-4',
          'text-content2-foreground',
        ],
      },
      ...listboxProps,
    }}
    popoverProps={{
      classNames: {
        base: 'rounded-lg',
        content: 'p-0 bg-content2 rounded-lg',
      },
    }}
    {...props}
  />
);

export const SelectItem = extendVariants(NextUISelectItem, {});

export const SelectSection = extendVariants(NextUISelectSection, {
  slots: {
    heading: 'uppercase font-medium text-default-500 px-4 py-2 text-sm',
  },
});

export default Select;
